import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"

import { Route, Routes } from "react-router-dom"

import { App } from "@/App"
import { AuthGate } from "@/components/auth/auth-gate"
import { HowItWorksRoute } from "@/routes/how-it-works"
import { ThemeProvider } from "@/components/layout/theme-provider"
import "./index.css"

const container = document.getElementById("root")
if (!container) throw new Error("Missing #root element")

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      {/* The router is outside the sign-in gate so that one page - How it
          works - can be read without an account. It shows no data, only how
          the system works. Everything else is behind the gate as before. */}
      <BrowserRouter>
        <Routes>
          <Route path="/how-it-works" element={<HowItWorksRoute />} />
          <Route
            path="/*"
            element={
              <AuthGate>
                <App />
              </AuthGate>
            }
          />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </StrictMode>,
)
